export default __webpack_public_path__ + "static/boxes-ca680f987189efe3b7a87c2585ec1433.jpg";